import React, { Component } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Routes from './routes';
import './App.css';
import './styles/design-system.css';

const theme = createTheme({
  palette: {
    primary: { main: '#0a72c4' },
    secondary: { main: '#0f2a42' },
    background: { default: '#f4f6f9' },
  },
  typography: {
    fontFamily: '"Lato", -apple-system, "Segoe UI", system-ui, sans-serif',
  },
  shape: { borderRadius: 9 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 700 },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: { borderRadius: 13, boxShadow: '0 18px 48px rgba(12,34,54,0.18), 0 6px 18px rgba(12,34,54,0.10)' },
      },
    },
  },
});

class App extends Component {
  render() {
    return (
      <div>
        <ThemeProvider theme={theme}>
          <Routes />
        </ThemeProvider>
      </div>
    );
  }
}

export default App;
